import { DDDFreespinBetPresentation } from "../freespin/DDDFreespinBetPresentation";

export class DDDRespinBetPresentation extends DDDFreespinBetPresentation {
    constructor(protected id: string = `DDDRespinBetPresentation`) {
        super(id);
    }
}
